module.exports = __webpack_public_path__ + "img/pwr_off2.8cba50e8.png";